module.exports = __webpack_public_path__ + "media/images/jumping/jumping-guy-m-97a034210ca24de6f4aff3114a0200ef.png";